import { BrowserModule } from '@angular/platform-browser';
import { NgModule, isDevMode } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withXhr, withInterceptorsFromDi } from '@angular/common/http';
import { EnvironmentConfiguration } from '@nts/std/environments';
import { StdModule, NtsAppRootModule } from '@nts/std';
import { environment } from 'src/environments/environment';
import { FormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { UNPROXIED_ENVIRONMENT } from '@nts/std/environments';
import { unproxiedEnvironmentFactory } from '@nts/std/environments';
import { environment as devEnvironment } from 'src/environments/environment.dev';
import { NtsBootService } from '@nts/std';
// import { RESPONSE_CACHE_SETTINGS_WEBWORKER_FACTORY } from '@nts/std';
// import { ResponseCacheWebWorkerSettings } from '@nts/std/src/lib/worker';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [BrowserModule,
AppRoutingModule,
BrowserModule,
BrowserAnimationsModule,
CommonModule,
FormsModule,
StdModule,
ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })],
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi()),

    {
      provide: EnvironmentConfiguration,
      useValue: { ...environment }
    },
    {
      provide: UNPROXIED_ENVIRONMENT,
      useFactory: unproxiedEnvironmentFactory(devEnvironment),
      deps: [EnvironmentConfiguration]
    },
    ...StdModule.getRootProviders(),
    // {
    //   provide: RESPONSE_CACHE_SETTINGS_WEBWORKER_FACTORY,
    //   useValue: {
    //     isEnabled: false
    //   } as ResponseCacheWebWorkerSettings
    // },
  ],
  bootstrap: [AppComponent]
})
export class AppModule extends NtsAppRootModule {
  constructor(
    bootService: NtsBootService,
  ) {
    super(bootService);
  }
}
